import React, { memo } from 'react';
import { useSearchParams } from 'react-router-dom';

import BackOfficeDrawer from 'components/drawers/BackOfficeDrawer';
import BackOfficeDeviceMapDeviceDetails from 'components/features/backOfficeDeviceMap/BackOfficeDeviceMapDeviceDetails';
import { SEARCH_PARAMS } from 'constants/search-params';

function BackOfficeDeviceMapDrawer(): JSX.Element {
  const [searchParams, setSearchParams] = useSearchParams();
  const deviceId = Number(searchParams.get(SEARCH_PARAMS.BACK_OFFICE.SELECTED_DEVICE));
  const visible = !!deviceId;

  const handleClose = () => {
    setSearchParams((prev) => {
      const newSearchParams = new URLSearchParams(prev);
      newSearchParams.delete(SEARCH_PARAMS.BACK_OFFICE.SELECTED_DEVICE);
      return newSearchParams;
    });
  };

  if (!deviceId) return <></>;

  return (
    <BackOfficeDrawer
      visible={visible}
      backOfficeSection="Device Information"
      actions={[]}
      handleClose={handleClose}
      noFooter={true}
    >
      <BackOfficeDeviceMapDeviceDetails deviceId={deviceId} />
    </BackOfficeDrawer>
  );
}

export default memo(BackOfficeDeviceMapDrawer);
